import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = () => {
  new priceBLOCKS;
};

class priceBLOCKS {
  constructor() {
    this.plan();
  }
  
  plan () {
    const planSlider = new Swiper('.p-price-plan__slide', {
      grabCursor: true,
      speed: 400,
      slidesPerView: 1.4,
      spaceBetween: 20,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      scrollbar: {
        el: '.p-price-plan__slide-bar',
        draggable: true,
      },
      navigation: {
        nextEl: '.p-price-plan__arrow--next',
        prevEl: '.p-price-plan__arrow--prev',
      },
      breakpoints: {
        500: {
          slidesPerView: 'auto',
          spaceBetween: 25,
        }
      },
    });
  }
}

export default function PRICE () {
  w.addEventListener('load', domReady);
}